import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import FlowerShop from '@/components/outlet/FlowerShop';

const flowerShops = () => {
  return (
    <>
      <Head>
        <title>Flower POS | Florist POS - Billing & Inventory Management</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/flower-shops" />
        <link rel="alternate" href="https://queuebuster.co/outlet/flower-shops" hrefLang="en-us" />
        <meta name="description" content="Optimize your flower shop with QueueBuster Florist POS. Manage billing, inventory, customer loyalty, and reporting with ease. Reduce wastage and increase profits." />
        <meta property="og:title" content="QueueBuster Florist POS - Streamline Sales, Inventory & Loyalty Management" />
        <meta property="og:description" content="QueueBuster Florist POS is designed for florists to enhance sales, manage inventory, and reduce wastage. Features include billing for flowers, customer loyalty programs, real-time inventory management, and powerful reporting tools. Boost your floral business today!" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG%2BImages%2Bwebsite%2Bpages-01.jpg" />
        <meta property="og:url" content="https://queuebuster.co/outlet/flower-shops" />
      </Head>
         <SchemaTags page="flower-shops" />
      <FlowerShop />
    </>
  )
}

export default flowerShops